// Action Types
export var GET_ALERTS_DASHBOARD = 'GET_ALERTS_DASHBOARD';
export var GET_ALERTS_DASHBOARD_SUCCESS = 'GET_ALERTS_DASHBOARD_SUCCESS';
export var GET_ALERTS_DASHBOARD_FAILURE = 'GET_ALERTS_DASHBOARD_FAILURE';
export var UPDATE_ALERTS_DASHBOARD_PAGE_NUMBER = 'UPDATE_ALERTS_DASHBOARD_PAGE_NUMBER';
export var CLEAR_ALERTS_DASHBOARD_STATE = 'CLEAR_ALERTS_DASHBOARD_STATE';
export var SET_ALERTS_FILTER = 'SET_ALERTS_FILTER';
// ✅ New Action Types for Devices
export var GET_ALERTS_DEVICES = 'GET_ALERTS_DEVICES';
export var GET_ALERTS_DEVICES_SUCCESS = 'GET_ALERTS_DEVICES_SUCCESS';
export var GET_ALERTS_DEVICES_FAILURE = 'GET_ALERTS_DEVICES_FAILURE';
// ✅ New Action Types for SOS/Falls
export var GET_ALERTS_SOS = 'GET_ALERTS_SOS';
export var GET_ALERTS_SOS_SUCCESS = 'GET_ALERTS_SOS_SUCCESS';
export var GET_ALERTS_SOS_FAILURE = 'GET_ALERTS_SOS_FAILURE';
